import { CacheState } from './computeCacheStateForScripts'

interface PrintDebugInfoArgs {
  cacheState: CacheState
  onlySameOrigin: boolean
  pathPrefixes: string[]
  rows: { path: string; encodedBodySize: number; transferSize: number }[]
  encodedBytes: number
  transferredBytes: number
}
export const printDebugInfo = ({
  cacheState,
  onlySameOrigin,
  pathPrefixes,
  rows,
  encodedBytes,
  transferredBytes,
}: PrintDebugInfoArgs) => {
  const fetched = rows.filter((r) => r.transferSize > 0)
  const notFetched = rows.filter((r) => r.transferSize === 0)

  // eslint-disable-next-line no-console
  console.groupCollapsed(
    `[cache_state] ${cacheState} | scripts=${rows.length} | fetched=${fetched.length} | not_fetched=${notFetched.length} | transferred=${transferredBytes}B | encoded=${encodedBytes}B`,
  )

  // eslint-disable-next-line no-console
  console.log('filters', { onlySameOrigin, pathPrefixes })

  if (fetched.length > 0) {
    // eslint-disable-next-line no-console
    console.groupCollapsed(`[cache_state] BODY fetched (${fetched.length})`)
    // eslint-disable-next-line no-console
    console.log(
      fetched.map(({ path, encodedBodySize, transferSize }) => ({
        path,
        encodedBodySize,
        transferSize,
      })),
    )
    // eslint-disable-next-line no-console
    console.groupEnd()
  } else {
    // eslint-disable-next-line no-console
    console.log('[cache_state] BODY fetched: none')
  }

  if (notFetched.length > 0) {
    // eslint-disable-next-line no-console
    console.groupCollapsed(`[cache_state] BODY not fetched (${notFetched.length})`)
    // eslint-disable-next-line no-console
    console.log(
      notFetched.map(({ path, encodedBodySize, transferSize }) => ({
        path,
        encodedBodySize,
        transferSize,
      })),
    )
    // eslint-disable-next-line no-console
    console.groupEnd()
  } else {
    // eslint-disable-next-line no-console
    console.log('[cache_state] BODY not fetched: none')
  }

  // eslint-disable-next-line no-console
  console.groupCollapsed('[cache_state] all considered scripts')
  // eslint-disable-next-line no-console
  console.log(
    rows.map(({ path, encodedBodySize, transferSize }) => ({
      path,
      body: encodedBodySize > 0 ? 'fetched' : 'not_fetched',
      encodedBodySize,
      transferSize,
    })),
  )
  // eslint-disable-next-line no-console
  console.groupEnd()

  // eslint-disable-next-line no-console
  console.groupEnd()
}
